import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { sessionService } from '../../application/SessionService';

type UseRemoveSessionResponseProps = ServiceResponse<() => void, void>;

// Hooks act as 'Adapter' layer.
const useDeleteSession = (): UseRemoveSessionResponseProps => {
  const { isLoading, isSuccess, isError, refetch } = useQuery(
    [`planner_session_logout`],
    () => sessionService.deleteSession(),
    {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: refetch,
  };
};

export default useDeleteSession;
